import { Injectable, } from '@angular/core';
import { Observable, catchError, map, of, switchMap } from 'rxjs';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CreateQuestionnairePageComponent } from './features/create-questionnaire-page/create-questionnaire-page.component';

@Injectable({
  providedIn: 'root',
})
export class SaveQuestionnarieGuard implements CanDeactivate<CreateQuestionnairePageComponent> {

  canDeactivate(component: CreateQuestionnairePageComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (component.indeactivate) {
      return false;
    }
    component.saveQuestionnarie()
    return true;
  }
}


